export default "__VITE_ASSET__Ctj$YVLX__"